export default {
  logout: 'Logout',
  languageMenu: {
    changeLanguage: 'Change language',
  },
}
